import styled from 'styled-components'
import { hFlex } from '../../../../../../../../../../Styles/style-helpers'

export const HeaderEl = styled.div`
  position: relative;
  ${hFlex};
  justify-content: flex-start;

  .right {
    ${hFlex};
    flex: 1;
    justify-content: flex-end;

    a {
      ${hFlex};
      text-transform: uppercase;
      letter-spacing: 0.0125em;

      svg {
        transform: scale(0.75);
      }

      &:nth-child(2) {
        flex-direction: row-reverse;
        margin-left: 5em;

        svg {
          transform: scale(-0.75);
        }
      }
    }
  }
`
